<template>
  <el-pagination
    v-model:current-page="currentPage"
    v-model:page-size="pageSize"
    :pager-count="pagerCount"
    :page-sizes="pageSizes"
    :layout="layout"
    :total="total"
    @size-change="handleSizeChange"
    @current-change="handleCurrentChange"
    size="small"
    background
  >
  </el-pagination>
</template>

<script setup>
import {
  onBeforeMount, onMounted, onUnmounted, onUpdated,
  computed, watch, ref
} from 'vue'
import { isNull, dayjs, message } from '@/utils/js/initVariable'

// props
const props = defineProps({
  total: { type: Number, default: () => { return 0 }, },
  page: { type: Number, default: () => { return 1 }, },
  limit: { type: Number, default: () => { return 20 }, },
  pagerCount: { type: Number, default: () => { return 5 }, },
  pageSizes: { type: Array, default: () => { return [10, 20, 30, 50, 100, 500, 1000] } },
  layouts: { type: String, default: 'total, sizes, prev, pager, next' },
})

// emit
const emit = defineEmits([
  'pageChange', 'update:page', 'update:limit',
])
const showMiddleText = ref(false)
let currentPage = computed({
  get() {
    return props.page
  },
  set(val) {
    emit('update:page', val)
  }
})

let pageSize = computed({
  get() {
    return props.limit
  },
  set(val) {
    emit('update:limit', val)
  }
})

const layout = computed(() => {
  return props.layouts;
  // return props.layouts === 'sizes, prev, pager, next'
  //   ? 'sizes, slot, prev, pager, next'
  //   : 'total, sizes, prev, pager, next'
})

// 组件挂载前
onBeforeMount(() => { })

// 组件挂载后
onMounted(() => { })

// 组件更新后
onUpdated(() => { })

// 组件销毁后
onUnmounted(() => { })

const handleSizeChange = () => {
  emit('pageChange')
}

const handleCurrentChange = () => {
  emit('pageChange')
}

watch(
  () => props.layouts,
  (newLayout) => {
    newLayout == 'sizes, prev, pager, next' ?
    document.documentElement.style.setProperty('--pagination-sizes-left', '0')
    :document.documentElement.style.setProperty('--pagination-sizes-left', '-14px')
  },
  { immediate: true }
)
</script>

<style lang='less'>
.pagination-contain {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .el-pagination__sizes {
    left: var(--pagination-sizes-left, 0);
  }
  .el-pagination--small button, .el-select__selected-item.el-select__placeholder {
    span {
      font-size: 15px;
    }
  }
  .el-pagination__total.is-first {
    font-size: 15px;
  }
  .is-active {
    background-color: rgb(18, 125, 213);
    color: var(--el-color-white);
  }
  .el-select__wrapper {
    box-shadow: 0 0 0 1px rgb(98, 127, 151) inset;
    min-height: 35px;
    border-radius: 8px;
  }
  .el-select__placeholder {
    font-size: 15px;
    line-height: 20px;
    color: rgb(158, 179, 205);
  }
  .el-icon {
    font-size: 20px;
    font-weight: bold;
  }
  .btn-prev, .btn-next, .is-active.number, li.number, .el-pager li  {
    width: 20px;
    height: 35px;
    border-radius: 8px;
  }
  .btn-prev, .btn-next, li.number {
    background-color: var(--domBackgroundColor) !important;
  }
  .is-active.number {
    background-color: rgb(18, 125, 213) !important;
  }
}
</style>

<style lang='less' scoped>
.pagination-contain {
  .pagination-middle-text {
    display: flex;
    flex: 1;
    min-width: 0;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 50px;
    font-size: 10px;
    left: 15px;
    line-height: 15px;
    color: var(--iconColor_9);
  }
}
</style>